import { CookieStorage } from 'app/base/services/cookie-storage.service';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { UserService } from 'app/base/services/user.service';
import { LocalDataStoreService } from 'app/base/services/local-data-store.service';
// import 'rxjs/add/operator/map';
import { map } from 'rxjs/operators';

@Injectable()
export class UserDataResolveGuardService  {
  constructor(
    private cookieStorage: CookieStorage,
    private userService: UserService,
    private localDataStoreService: LocalDataStoreService
  ) {
  }

  resolve(): Observable<any> {
    const token = this.cookieStorage.getCookie('token');
    if (token) {
      return this.userService.getUserData().pipe(map(userData => {
        if (userData && userData.data) {
          this.localDataStoreService.updateData(userData.data);
          return userData.data;
        } else {
          /** */
        }
      }));
    }
  }
}
